/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Results_Half_HourInputs */

const en_onboarding_results_half_hour = /** @type {(inputs: Onboarding_Results_Half_HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0.5 hours`)
};

const es_onboarding_results_half_hour = /** @type {(inputs: Onboarding_Results_Half_HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0.5 horas`)
};

/**
* | output |
* | --- |
* | "0.5 hours" |
*
* @param {Onboarding_Results_Half_HourInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_results_half_hour = /** @type {((inputs?: Onboarding_Results_Half_HourInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Results_Half_HourInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_results_half_hour(inputs)
	return en_onboarding_results_half_hour(inputs)
});